import { useQuery } from '@tanstack/react-query';
import type { FeatureCollection, Point } from 'geojson';
import { DATA_BASE_URL } from '@/data';
import { activeMapCountry, activeMapCountryConfig } from '@/data/active-country';
import { countryDataPath } from '@/features/map-core/countries';
import type { PoiCategory } from './types';
import { POI_CONFIG } from './poi-config';

type PoiFeatureCollection = FeatureCollection<Point, Record<string, unknown>>;

export function usePoiData(category: PoiCategory) {
  const cfg = POI_CONFIG[category];
  return useQuery({
    // Страна в ключе: у каждой страны свой набор POI под теми же категориями.
    queryKey: ['poi', activeMapCountry(), category],
    queryFn: async (): Promise<PoiFeatureCollection> => {
      const path = countryDataPath(activeMapCountryConfig(), `poi/${cfg.file}`);
      const res = await fetch(`${DATA_BASE_URL}/${path}`);
      if (!res.ok) throw new Error(`Failed to load POI: ${cfg.file} (${res.status})`);
      return res.json();
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
